import { start } from "single-spa";
import {
  constructApplications,
  constructLayoutEngine,
  constructRoutes,
} from "single-spa-layout";

import {
  agConsultasProps,
  agdExamesProps,
  agdExamsUnauthenticatedProps,
  attendanceProps,
  cartProps,
  coaProps,
  componentCardsProps,
  consultaAgendadaProps,
  dataErrorTelemedicinaProps,
  examesProps,
  forwardingProps,
  globalErrorsProps,
  homeProps,
  institutionalProps,
  legacyAppProps,
  medicalRequestsProps,
  minhasConsultasProps,
  navbarProps,
  navHospitalsProps,
  paginasDeslogadasProps,
  portableScheduleProps,
  posConsultationProps,
  privacyProps,
  profileProps,
  redirecionamentoTelemedicinaProps,
  sistemaIndisponivelTelemedicinaProps,
  statusProps,
  vacinasProps,
} from "./layouts/nsw-apps-props";
import nswLayout from "./layouts/nsw-layout.html";

import { addUnloadAppsEvent, assignBasename, redirects } from "./events";

import { listChildRoutes } from "utils/listChildRoutes";

import "./assets/scss/styles.scss";
import { customAppConfigs, customApplication } from "./custom-register";

export async function config() {
  const defaultLoader = require("./layouts/components/loader.html");
  const defaultError = require("./layouts/components/error.html");

  const data = {
    props: {
      componentCardsProps,
      globalErrorsProps,
      homeProps,
      institutionalProps,
      navbarProps,
      legacyAppProps,
      coaProps,
      attendanceProps,
      paginasDeslogadasProps,
      examesProps,
      agConsultasProps,
      agdExamesProps,
      agdExamsUnauthenticatedProps,
      cartProps,
      medicalRequestsProps,
      minhasConsultasProps,
      navHospitalsProps,
      consultaAgendadaProps,
      profileProps,
      vacinasProps,
      privacyProps,
      statusProps,
      forwardingProps,
      posConsultationProps,
      portableScheduleProps,
      redirecionamentoTelemedicinaProps,
      dataErrorTelemedicinaProps,
      sistemaIndisponivelTelemedicinaProps,
    },
    loaders: {
      defaultLoader,
    },
    errors: {
      defaultError,
    },
  };

  const routes = constructRoutes(nswLayout, data);

  const applications = constructApplications({
    routes,
    loadApp({ name }) {
      return System.import(name);
    },
  });

  const layoutEngine = constructLayoutEngine({ routes, applications });
  applications.forEach((app) => customApplication(app, customAppConfigs));

  addUnloadAppsEvent();
  redirects();

  const plataformaLegacyRoutes = listChildRoutes(routes, "plataforma");
  assignBasename(plataformaLegacyRoutes, "plataforma");

  layoutEngine.activate();
}

config().then(() => start());
